import React from "react";
import "./BannerDirectorio.css";

export default function BannerDirectorio() {
  return (
    <section className="banner-directorio">
      <div className="banner-color-directorio">
        <div className="banner-content-directorio">
          <div className="banner-text-directorio">
            <h1 className="banner-title-directorio">Directorio Médico</h1>
          </div>
        </div>
      </div>
    </section>
  );
}